import React from 'react';

import ThemeIcon from '@atlaskit/icon/core/theme';

export const ThemesIcon = (): React.JSX.Element => <ThemeIcon label="" spacing="spacious" />;
